module.exports = (userAuth = []) => {
    if (userAuth.indexOf('mvpd') !== -1) {
        return 'authenticated';
    } else if (userAuth.indexOf('isp') !== -1) {
        return 'ISP';
    }
    return 'not authenticated';
};



// WEBPACK FOOTER //
// ./app/lib/auth/getAccessMethodFromAuthTypes.js